export enum LoginStatusEnum {
  Checking = 'CHECKING',
  Success = 'SUCCESS',
  Expired = 'EXPIRED',
  Error = 'ERROR',
}
